import React from "react";

/**
 * TeamFlag — renders a team's circular flag using hatscripts/circle-flags CDN.
 * Falls back to emoji if the iso_code is missing or image fails.
 */
export default function TeamFlag({ team, size = 56, className = "" }) {
  const [isoFailed, setIsoFailed] = React.useState(false);
  const [crestFailed, setCrestFailed] = React.useState(false);
  const iso = team?.iso_code;
  const crest = team?.crest_url;
  const px = typeof size === "number" ? `${size}px` : size;

  return (
    <div
      className={`rounded-full bg-neutral-50 border border-neutral-200 overflow-hidden flex items-center justify-center shadow-inner flex-shrink-0 ${className}`}
      style={{ width: px, height: px }}
    >
      {iso && !isoFailed ? (
        <img
          src={`https://hatscripts.github.io/circle-flags/flags/${iso.toLowerCase()}.svg`}
          alt={team?.name || ""}
          onError={() => setIsoFailed(true)}
          className="w-full h-full object-cover"
        />
      ) : crest && !crestFailed ? (
        <img
          src={crest}
          alt={team?.name || ""}
          onError={() => setCrestFailed(true)}
          className="w-full h-full object-contain p-0.5"
        />
      ) : (
        <span className="text-2xl leading-none">{team?.flag || "🏳️"}</span>
      )}
    </div>
  );
}
